
import Checkbox from '@mui/material/Checkbox'

import { useMatomo } from '@jonkoops/matomo-tracker-react'


import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import {
  useNavigate,
} from 'react-router'
import {
  Link,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  FiltersBox,
} from '$src/components'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  SchedulesCtx,
} from '$src/components/schedules'
import {
  defaultSavedQuery,
  ImportListModal,
  QueriesCtx,
} from '.'


/**
 * QueriesModal
 * From mainMenu
**/
const QueriesModal = (props) => {
  // logg(props, 'QueriesModal')

  /* ctx */

  const apiRouter = useApiRouter()
  const { trackPageView, trackEvent } = useMatomo()
  const navigate  = useNavigate()

  const {
    actionName, setActionName,
    cuEmail,
    customerId,
    deleteModalOpen, setDeleteModalOpen,
    loading,    setLoading,
    renameModalOpen, setRenameModalOpen,
    scope, setScope,
    selectedResource, setSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in QueriesModal')

  const {
    bank,                 setBank,
    banksSearchModalOpen, setBanksSearchModalOpen,
    query,                setQuery, // the clauses of a query
    selectedBanks,        setSelectedBanks,
  } = useContext(BanksCtx)

  const {
    list,               setList,
    listName,           setListName,
    queriesList,        setQueriesList,        refreshQueriesList,
    queryModalOpen,     setQueryModalOpen,
    queriesModalOpen,   setQueriesModalOpen,
    savedQuery,         setSavedQuery, // for modifying a saved query via BanksSearchModal. name and isMerge
    selectedQueries,    setSelectedQueries,
    shareModalOpen,     setShareModalOpen,
    importListModalOpen, setImportListModalOpen,
  } = useContext(QueriesCtx)
  // logg(useContext(QueriesCtx), 'QueriesCtx in QueriesModal')

  const {
    setOneResultTitle, defaultOneResultTitle,
  } = useContext(SchedulesCtx)

  /* state */

  /* effects */

  /* scope */
  const [ filteredQueriesList, setFilteredQueriesList ] = useState(queriesList)
  useEffect(() => {
    const tmp = queriesList.filter((r, idx) => {
      return scope[r.scope]
    })
    setFilteredQueriesList(tmp)
  }, [ queriesList, scope ])

  useEffect(() => {
    trackEvent({ category: 'QueriesModal', action: 'show' })
  }, [ queriesModalOpen ])

  /* methods */

  const handleClear = () => {
    setSelectedResource(defaultSavedQuery)
    setSelectedQueries({})
  }

  const handleClone = () => {
    setLoading(true)
    fetch(apiRouter.queryClonePath({ id: selectedResource.id }), { method: 'POST' }).then(r => r.json()).then(() => {
      toast('Cloned the query')
    }).catch(err => {
      logg(err, 'err')
      toast('Could not clone the query.')
    }).finally(async () => {
      setLoading(false)
      await refreshQueriesList()
      setSelectedQueries({})
      // setResults([])
      // navigate('/')
    })
  }

  /*
   * handleEdit()
   * does not call setSelectedQueries({}) b/c the api returns scope='mine', UI is unbroken
  **/
  const handleModify = () => {

    if (selectedResource.id) {
      switch (selectedResource.kind) {
        case C.kinds.Query:
          setActionName(C.queries_actions.modify)
          setLoading(true)
          fetch(apiRouter.queryPath({id: selectedResource.id })).then(r => r.json()).then(inn => {

            setSavedQuery(inn) // name and isMerged.
            setQuery(inn.query) // actually setClauses
            setBanksSearchModalOpen(true)
            setQueriesModalOpen(false)

          }).catch((err) => {
            logg(err, 'could not get query')
          }).finally(() => {
            setLoading(false)
          })
          break

        case C.kinds.List:
          setSavedQuery({...selectedResource})
          setActionName(C.lists_actions.modify)
          setQueryModalOpen(true)
          break

        default:
          alert('098 - this should never happen')
          logg('098 - this should never happen')
      }
    } else {
      alert('099 - this should never happen')
      logg('099 - this should never happen')
    }
  }

  const handleRename = () => {
    setRenameModalOpen(true)
    setActionName(C.queries_actions.rename) // C.lists_actions.rename is eq C.queries_actions.rename
  }

  const handleShare = () => {
    setLoading(true)
    fetch(apiRouter.queryPath({ id: selectedResource.id })).then(r => r.json()).then(inns => {
      logg(inns, 'gotShare')

      setSavedQuery(inns)
      setShareModalOpen(true)
      setLoading(false)
    })
  }

  const handleView = () => {
    setQueriesModalOpen(false)
    setSelectedBanks({})
    setSelectedQueries({})
    setOneResultTitle(null)
    setActionName(C.actions['banks#results'])
  }

  const toggleSelectedQueryId = (which) => {
    const _tmp = { ...selectedQueries }
    if (_tmp[which.id]) {
      delete _tmp[which.id]
    } else {
      _tmp[which.id] = which.id
    }
    setSelectedQueries(_tmp)
  }
  useEffect(() => {
    // logg(selectedQueries, 'selectedQueries')
    if (Object.keys(selectedQueries).length === 1) {
      const _qId = selectedQueries[Object.keys(selectedQueries)[0]]
      const _q = queriesList.filter((item, idx) => item.id === _qId)[0]
      setSelectedResource(_q)
    } else {
      logg('setting default saved query')
      setSelectedResource(defaultSavedQuery)
    }
  }, [ selectedQueries ])

  return <F>
    <ImportListModal />
    <Modal
      ariaHideApp={false}
      className="Boxed2Modal BaseModal DoL"
      isOpen={queriesModalOpen}
      onRequestClose={() => {
        handleClear()
        setQueriesModalOpen(false)
        setSelectedResource({})
        setSelectedQueries({})
      } }
      overlayClassName="ModalOverlay-z5"
    >
      <div className='header'>
        <h5 >Saved Lists and Queries: Lists (L) Queries (Q) and Merges (M)</h5>
        <div className='close' onClick={() => {
          handleClear()
          setQueriesModalOpen(false)
          setSelectedResource({})
          setSelectedQueries({})
        } }>&times;</div>
      </div>

      <div className='C1'>

        <div className='boxedList'>
          <div className='boxedListC'
            onClick={(event) => {
              if(event.target === event.currentTarget) {
                handleClear()
                setSelectedQueries({})
              }
            } }
          >
            { /* Queries list */ }
            { filteredQueriesList.map((opt, idx) => <div key={idx}
                className={`item-1 ${!!selectedQueries[opt.id] ? 'active' : ''}`}
                onClick={() => toggleSelectedQueryId(opt)}
            >
              <div className='left'>
                <input type='checkbox'
                  checked={!!selectedQueries[opt.value]}
                  readOnly={true}
                />
                &nbsp;&nbsp;&nbsp;{ opt.label } ({opt.kind === 'list' ? 'L' : 'Q'}{opt.is_merge ? 'M' : ''})
              </div>
              <div className='right'>
                { opt.email === cuEmail && 'mine' }
                { opt.email === 'reports@fedfis.com' && 'standard' }
                { [cuEmail, 'reports@fedfis.com'].indexOf(opt.email) === -1 && <F>by { opt.email }</F> }
              </div>
            </div> )}
          </div>
        </div>

        <div className='actions-vertical DoL'>
          { selectedResource.id && 'mine' === selectedResource.scope &&
            <button className='Btn ' onClick={handleModify} >Modify</button> ||
            <button className='Btn btn-disabled'>Modify</button> }

          { selectedResource.id && 'mine' === selectedResource.scope &&
            <button className='Btn ' onClick={handleRename} >Rename</button> ||
            <button className='Btn btn-disabled'>Rename</button> }

          { selectedResource.id &&
            <button className='Btn ' onClick={handleClone} >Clone</button> ||
            <button className='Btn btn-disabled'>Clone</button> }

          { selectedResource.id && 'mine' === selectedResource.scope &&
            <button className='Btn' onClick={() => setDeleteModalOpen(true) } >Delete</button> ||
            <button className='Btn btn-disabled'>Delete</button> }

          { selectedResource.id && 'mine' === selectedResource.scope &&
            <button className='Btn ' onClick={handleShare} >Share</button> ||
            <button className='Btn btn-disabled'>Share</button> }

          <button className='Btn'
            onClick={() => setImportListModalOpen(true) }
          >Import List</button>

          <button className='Btn'
            onClick={() => {
              refreshQueriesList().then(() => {
                setSelectedQueries({})
                toast('Refreshed Lists and Queries')
              })
            } } >Refresh</button>
        </div>

      </div>

      <FiltersBox onChange={() => setSelectedQueries({}) } />

      <div className='actions'>
        <div className='left'>
        </div>
        <div className='right'>
          { Object.keys(selectedQueries).length ? <Link to={appRouter.queriesViewPath({ selectedQueries }) } >
            <button className='Btn btn-primary' onClick={handleView} >View</button>
          </Link> : <button className='Btn btn-disabled'>View</button> }
        </div>
      </div>
    </Modal>
  </F>
}
export default QueriesModal
